import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "../components/GSRoutes/PrivateRoute";

const LinkQueryManager = lazy(() => import("./QueryManager/LinkQueryManager"));
const Etl = lazy(() => import("./ETLView/etlview"));
const GSLogin = lazy(() => import("../components/GSHelperComponents/GSLogin"));
const StartingPage = lazy(() => import("./StartingPage/StartingPage"));
const LearnPage = lazy(() => import("./LearnPage/LeanPage"));
const HelpPage = lazy(() => import("./HelpView/HelpPage"));
const Register = lazy(() => import("./Register/Register"));
const RegisterApp = lazy(() => import("./Register/RegisterApp"));
const MissionControl = lazy(() => import("./MissionControl/MissionControl"));
const UserSpace = lazy(() => import("./UserSite/UserSpace"));
const FileManager = lazy(() => import("./FileManager/filemanager"));
const JobView = lazy(() => import("./JobView/JobView"));
const ThorView = lazy(() => import("./ThorView/ThorView"));
const CVAView = lazy(() => import("./CVAManager/CVAView"));
const RXAView = lazy(() => import("./RXA/RXA"));
const RXAAPPView = lazy(() => import("./RXA/RXAApp"));
const CameraViewApp = lazy(() => import("./RXA/CameraViewApp"));
const CameraView = lazy(() => import("./RXA/CameraView"));
const RTCStreamer = lazy(() => import("../components/rxa/RTCStreamer"));
const StreamerSetupNew = lazy(() => import("./Streamer/StreamerNew"));
const GMEditor = lazy(() => import("./Editor/GMEditor"));
const DocumentsEditor = lazy(() => import("./Documents/DocumentEditor"));
const Checkout = lazy(() => import("./Register/Checkout"));
const EmployeeView = lazy(() => import("./employees/Employees"));
const GMMeldung = lazy(() => import("./Meldung/GMMeldung"));
const GMMeldungAPP = lazy(() => import("./Meldung/GMMeldungAPP"));
const MasterData = lazy(() => import("./MasterData/MasterData"));
const ResetPassword = lazy(() => import("./User/ResetPassword"));
const ForgotPassword = lazy(() => import("./User/ForgotPassword"));

const Start = lazy(() => import("./Start/Start"));

export const websiteRoutes = (setLoggedIn, setError, newMessage) => {

    var isflutter = typeof window.flutter_inappwebview !== 'undefined'
    // var isflutter = true

    return (
        <Suspense fallback={<div />}>
            <Switch>
                <Route path="/login" render={(props) => {
                    return <GSLogin />
                }} />

                <Route path="/resetpassword" render={(props) => {
                    return <ResetPassword />
                }} />

                <Route path="/forgotpassword" render={(props) => {
                    return <ForgotPassword />
                }} />

                <PrivateRoute path="/data" content={<LinkQueryManager />} />
                <PrivateRoute path="/etl" content={<Etl />} />

                <PrivateRoute path="/user" content={<UserSpace />} />
                <PrivateRoute path="/controlcenter" content={<MissionControl newMessage={newMessage} />} />
                <PrivateRoute path="/files" content={<FileManager />} />
                <PrivateRoute path="/jobs" content={<JobView />} />
                <PrivateRoute path="/thor" content={<ThorView />} />
                <PrivateRoute path="/cxa" content={<CVAView />} />
                <PrivateRoute path="/rxa/camera/:name" content={<RTCStreamer />} />

                {isflutter ?
                    <PrivateRoute path="/rxa/:name/:view" content={<CameraViewApp />} /> :
                    <PrivateRoute path="/rxa/:name/:view" content={<CameraView />} />
                }

                {isflutter ?
                    <PrivateRoute path="/rxa" content={<RXAAPPView />} /> :
                    <PrivateRoute path="/rxa" content={<RXAView />} />
                }

                <PrivateRoute path="/streamer" content={<StreamerSetupNew />} />
                <PrivateRoute path="/start" content={<Start />} />
                <PrivateRoute path="/help" content={<HelpPage />} />

                <PrivateRoute path="/editor" content={<GMEditor />} />
                <PrivateRoute path="/documents" content={<DocumentsEditor />} />
                <PrivateRoute path="/masterdata" content={<MasterData />} />
                <PrivateRoute path="/users" content={<EmployeeView />} />
                {/* <PrivateRoute path="/stats" content={<StatsView />} /> */}

                {isflutter ?
                    <PrivateRoute path="/meldung" content={<GMMeldungAPP />} /> :
                    <PrivateRoute path="/meldung" content={<GMMeldung />} />
                }

                <Route path="/learn" exact render={(props) => { return <LearnPage /> }} />

                {isflutter ?
                    <Route path="/register" exact render={(props) => { return <RegisterApp /> }} /> :
                    <Route path="/register" exact render={(props) => { return <Register /> }} />
                }

                <Route path="/checkout" exact render={(props) => { return <Register /> }} />
                <Route path="/registerAIconfirm" render={(props) => { return <Register /> }} />
                <Route path="/" exact render={(props) => { return <GSLogin /> }} />
            </Switch>
        </Suspense>
    )
}

export const APIURL = () => {

    let prodai = `${window.location.origin}/frontend`
    // let prodai = "http://localhost:8091/frontend"
    // let prodai = "http://10.0.2.2:8091/frontend"

    var ensservice = prodai
   

    return {
        readAllLinksForClass: prodai + "/linkeddataanalyzer/links/",
        readDataLinksForClass: prodai + "/linkeddataanalyzer/dtabledatalinks/",
        readERPDataLinksForClass: prodai + "/linkeddataanalyzer/erpdatalinks/",
        relations: prodai + "/linkeddataanalyzer/relations",
        readBuildInfo: prodai + "/linkeddataanalyzer/buildinfo/",
        readLevel1dTables: prodai + "/linkeddataanalyzer/erplevel1",
        readLevel2dTables: prodai + "/linkeddataanalyzer/level2",
        readRangeForDataLink: prodai + "/linkeddataanalyzer/datalinks/range/",
        readForeignLinkNamesFordTable: prodai + "/linkeddataanalyzer/foreignlinks/names/",
        readExtendedPropertiesAndRanges: prodai + "/linkeddataanalyzer/propertyrange/",
        // graphqlQuery: queryservice + "/gsgraphql",
        graphqlQuery: prodai + "/gslmaa",
        // graphqlQuery: queryservice + "/gslmaa",
        // graphqlQuerylmaa: queryservice + "/gslmaa",asasd

        

        register: prodai + "/registerai",
        confirmLogin: prodai,

        // confirmRegister: ensservice + "/registerconfirm/",
        oauthCred: prodai + "/user/oauth",
        // oauthCredDetails: ensservice + "/user/oauth/details",
        deleteOauthCredDetails: prodai + "/user/oauth/",

        userInfo: prodai + "/user/info",
        getAllUsers: prodai + "/user/account",
        createUser: prodai + "/user/account",
        deleteUser: prodai + "/user/account/delete",
        updateUser: prodai + "/user/account/update",

        forgetPassword: "/forgotPassword",
        sendpasswordreset: prodai + "/user/resetPasswordReact",
        checkTokenPassword: prodai + "/user/changePasswordReact",
        savePassword: prodai + "/user/savePasswordReact",


        databases: prodai + "/user/database",
        // getSharedDatabases: ensservice + "/user/shareddatabase",
        getActiveDatabase: prodai + "/user/database/active",
        createCompany: prodai + "/user/createCompany",
        getCNodes: prodai + "/user/cnodes",
        deleteCNodes: prodai + "/user/cnode/",

        shareDatabase: prodai + "/user/share/database",
        deleteSharedUser: prodai + "/user/share/database/delete",

        ensservice: prodai,

        getFiles: prodai + "/storage/files",
        getFile: prodai + "/storage/file",
        getFolder: prodai + "/storage/folder",
        getFolderContent: prodai + "/storage/folder/",
        getThumbNail: prodai + "/storage/thumbnail/",
        vodLimitUsage: prodai + "/storage/vod/usage",
        getVODFolder: prodai + "/storage/vod/folder",

        websocket: prodai + "/gs-guide-websocket?gssession=",
        restartCNodeChannelPipeline: prodai + "/missioncontrol/channelpipelines/rva/restart",
        checkPipelineConsistency: prodai + "/missioncontrol/channelpipelines/rva/check",
        triggerGlobalPipeline: prodai + "/missioncontrol/pipeline/",

        pipeline: prodai + "/missioncontrol/pipeline",
        streamkey: prodai + "/streaming/keys",

        toggleVod: prodai + "/streaming/vodEnable",
        streamInfo: prodai + "/streaming/live",
        streamkeyDelete: prodai + "/streaming/keys/delete",
        streams: prodai + "/live/",
        viewVod: prodai + "/videos/index.m3u8",
        login: prodai + "/auth/login",
        ping: prodai + "/ping",
        turnserver: prodai + "/user/turn"
    }
}
